import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

import '../../elements/Editor/styles.scss';

const MarkDownContent = ({children}) => {
    return (
        <ReactMarkdown rehypePlugins={[rehypeRaw]} className={"not-prose slate-editor"}>
            {children}
        </ReactMarkdown>
    )
}

export default MarkDownContent
